import React from 'react';

import classes from './PremiumFeatureBanner.module.scss';
import LinkButton from '../linkbutton/LinkButton';

const PremiumFeatureBanner = () => {
    return (
        <div className={classes['wrapper']}>
            <h3>Unlock Pharmuni Premium Benefits !</h3>
            <div className='row'>
                <div className='col-lg-6 col-12'>
                    <h5>Personalized Career Coaching </h5>
                    <p>Get guidance from experts to accelerate your career growth and achieve your professional goals. </p>

                    <h5 className='mt-5'>AI-Powered Progress Monitoring  </h5>
                    <p>Track your development with our AI-based Skill Tree and stay focused on enhancing your key competencies.  </p>
                </div>
                <div className='col-lg-6 col-12'>
                    <h5>Professional Resume & Cover Letter Builder   </h5>
                    <p>Build a professional resume and cover letter with pre-built templates to showcase your skills and stand out to employers</p>

                    <h5 className='mt-5'>Track Your Job Applications  </h5>
                    <p>Organize and monitor all your job applications in one place to streamline your application process </p>
                </div>
            </div>
            <div className='d-flex align-items-center justify-content-center'>
                <LinkButton kind='primary-color' to={'/plans'}>
                    Go Premium
                </LinkButton>
            </div>
        </div>
    );
};

export default PremiumFeatureBanner;